import { Component, ViewChild } from "@angular/core";
import { IonicPage, NavController, NavParams, Content } from "ionic-angular";
import { ConectorProvider } from "../../providers/conector/conector";
import { ComunicacionPage } from "../comunicacion/comunicacion";
import { NuevaComunicacionPage } from "../nueva-comunicacion/nueva-comunicacion";

/**
 * Generated class for the ComunicacionesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-comunicaciones",
  templateUrl: "comunicaciones.html"
})
export class ComunicacionesPage {
  @ViewChild(Content) content: Content;

  comunicaciones: any;
  data: any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private conector: ConectorProvider
  ) {
    this.data = {
      background: "assets/images/background/39.jpg"
    };

    this.conector.getComunicaciones().subscribe(data => {
      console.log("mensajes", data);
      this.comunicaciones = data["mensajes"];
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad ComunicacionesPage");
  }
  ionViewWillEnter() {
    this.conector.getComunicaciones().subscribe(data => {
      console.log("mensajes", data);
      this.comunicaciones = data["mensajes"];
    });
  }

  iraMensaje(mensaje) {
    this.navCtrl.push(ComunicacionPage, { mensaje: mensaje });
  }

  nuevoMensaje() {
    this.navCtrl.push(NuevaComunicacionPage);
  }

  doRefresh(refresher) {
    setTimeout(() => {
      this.conector.getComunicaciones().subscribe(data => {
        console.log("mensajes", data);
        this.comunicaciones = data["mensajes"];
      });
      refresher.complete();
    }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/comunicaciones/comunicaciones.ts